import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { isNativeHref } from './ActionLink';
interface TextLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}
export function TextLink({
  to,
  children,
  className = ''
}: TextLinkProps) {
  const classes = `group inline-flex items-center gap-1.5 type-button font-bold text-brand underline decoration-2 underline-offset-4 transition-colors duration-150 hover:text-brand-hover active:text-brand-press ${className}`;
  const inner = <>
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-0.5" aria-hidden="true" data-id="element-892" data-mp="2vyq9b1ai7m14" />
    </>;
  if (isNativeHref(to)) {
    const external = to.startsWith('http');
    return <a href={to} className={classes} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined} data-id="element-893" data-mp="3ogluwuss8j6n">
        {inner}
      </a>;
  }
  return <Link to={to} className={classes} data-id="element-894" data-mp="3ejl9gl283zeh">
      {inner}
    </Link>;
}